/** @format */

import React from 'react';

import {Typography} from '@mui/material';

import {DigitFieldProps} from 'pages/Home/Main/Project/components/AiModule/types';

import {StyledTextField} from '../styles';

const DigitField: React.FC<DigitFieldProps> = ({
  value,
  onChange,
  placeholder = 'Не обязательно',
  symbol,
  disabled = false,
}) => {
  return (
    <StyledTextField
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      fullWidth
      disabled={disabled}
      slotProps={{
        input: {
          endAdornment: (
            <Typography variant='body2' sx={{color: '#888888'}}>
              {symbol}
            </Typography>
          ),
        },
      }}
    />
  );
};

export default DigitField;
